module.exports = __webpack_public_path__ + "static/media/video.cc6b77ab.mp4";